import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { documentId }: Boundaries["retrieveDocumentKey"]["request"],
): State {
  return [
    ...state,
    {
      documentId,
      request: setRequestStateToPending(),
      key: "",
    },
  ];
}

function handleSuccess(
  state: State,
  { documentId, key }: Boundaries["retrieveDocumentKey"]["success"],
): State {
  return [
    {
      documentId,
      request: setRequestStateToSuccess(),
      key,
    },
  ];
}

function handleFailure(
  state: State,
  { documentId }: Boundaries["retrieveDocumentKey"]["failure"],
): State {
  return [
    ...state,
    {
      documentId,
      request: setRequestStateToFailure(),
      key: "",
    },
  ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveDocumentKeyRequested]: handleRequest,
    [events.retrieveDocumentKeySucceeded]: handleSuccess,
    [events.retrieveDocumentKeyFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
